import React from 'react';
import styled from 'styled-components/macro';
import { LinkButton } from '../shared/Button';
import { PageLoadingIndicator } from '../shared/LoadingIndicator';
import { fadeIn } from '../styling/animations';
import { spacing06 } from '../styling/spacing';
import { AuthenticationProps } from './AuthenticationProvider';

type Props = AuthenticationProps & { children?: React.ReactNode };

export const AuthenticationFlow = (props: Props) => {
  if (props.isLoggingIn) {
    return (
      <CenteredContainer>
        <div>
          <PageLoadingIndicator />
          Logging in...
        </div>
      </CenteredContainer>
    );
  }

  if (props.isLoggingOut) {
    return (
      <CenteredContainer>
        <div>
          <PageLoadingIndicator />
          Logging out...
        </div>
      </CenteredContainer>
    );
  }

  if (props.authenticationError != null) {
    return (
      <CenteredContainer>
        <div>
          <p>Sorry, something went wrong while logging you in.</p>
          <RetryButtonContainer>
            <LinkButton onClick={props.redirectToLogin}>Try again</LinkButton>
          </RetryButtonContainer>
        </div>
      </CenteredContainer>
    );
  }

  if (props.isAuthenticated) {
    return <>{props.children}</>;
  }

  return (
    <CenteredContainer>
      <PageLoadingIndicator />
    </CenteredContainer>
  );
};

const CenteredContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  animation: ${fadeIn} 0.5s ease-in both;
`;

const RetryButtonContainer = styled.div`
  margin-top: ${spacing06};
`;
